/**
 * Expandable sections.
 */
class Expandable {
	/**
	 * Add event handlers to expand buttons.
	 *
	 * @param { Element } container A DOM element that contains the buttons to apply behaviour to.
	 */
	constructor( container ) {
		this.buttons = container.querySelectorAll( 'button[aria-expanded][aria-controls]' );

		this.buttons.forEach( ( button ) => {
			const expandable = document.getElementById( button.getAttribute( 'aria-controls' ) );
			if ( ! expandable ) {
				return;
			}
			const expanded = ( button.getAttribute( 'aria-expanded' ) === 'true' );
			expandable.hidden = ! expanded;
			button.addEventListener( 'click', this.expandableButtonClick );
		} );
	}

	/**
	 * Expandable button click handler.
	 *
	 * Toggle aria-expanded attribute on button and expandable section hidden property when the button is clicked.
	 *
	 * @param {Event} event Click event on a button that expands a section.
	 */
	expandableButtonClick( event ) {
		event.preventDefault();

		const button = event.target;
		const expandable = document.getElementById( button.getAttribute( 'aria-controls' ) );
		if ( ! expandable ) {
			return;
		}
		const expanded = ( button.getAttribute( 'aria-expanded' ) === 'true' );
		expandable.hidden = expanded;
		button.setAttribute( 'aria-expanded', ! expanded );

		if ( button.hasAttribute( 'data-opened-label' ) ) {
			const toReplace = button.innerHTML;
			button.innerHTML = button.getAttribute( 'data-opened-label' );
			button.setAttribute( 'data-opened-label', toReplace );
		}
	}

	/**
	 * Removes event listeners.
	 */
	unmount() {
		this.buttons.forEach( ( button ) => {
			button.removeEventListener( 'click', this.expandableButtonClick );
		} );
	}
}

export default Expandable;
